// Montos en pesos que se teclean o se pegan (`$1,572.50`, `-200`): se agrupan en vivo y viajan en
// centavos. Un campo de texto, no `type="number"`: la rueda del ratón no lo cambia y `1e3` no pasa.
import { groupTypedAmount, parseAmount } from '@/shared/lib/format/amount';
import { DECIMALS } from './ruleForm';

const NOT_AN_AMOUNT = 'Escribe solo el monto en pesos, por ejemplo 1,572.50.';

/** Lo tecleado con comas de miles; con `signed` conserva el signo. Lo que no es monto queda igual. */
export function typedPesos(text: string, signed = false): string {
    if (/[^\d.,$\s-]/.test(text)) return text;
    const grouped = groupTypedAmount(text);
    return signed && text.trimStart().startsWith('-') ? `-${grouped}` : grouped;
}

/** Pesos a centavos (`$1,572.50` → 157250, `-200` → -20000); `null` si no es un monto. */
export function pesosToCents(text: string): number | null {
    const trimmed = text.trim();
    const negative = trimmed.startsWith('-');
    const value = parseAmount(negative ? trimmed.slice(1) : trimmed);
    if (value === null) return null;
    const cents = Math.round(value * 100);
    return negative ? -cents : cents;
}

/** Centavos a lo que se teclea: 157250 → "1,572.50". */
export function centsToPesos(cents: number): string {
    const text = groupTypedAmount((Math.abs(cents) / 100).toFixed(2));
    return cents < 0 ? `-${text}` : text;
}

/** Por qué lo tecleado no se lee como monto: más de dos decimales o algo que no es número. */
export function invalidAmountMessage(text: string): string {
    return /^-?\d*\.\d{3,}$/.test(text.replace(/[,\s$]/g, '')) ? DECIMALS : NOT_AN_AMOUNT;
}
